import React from "react";
import { useSelector } from "react-redux";
import { EmptyComponent } from "../common/EmptyComponent.js";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { AppFeatures } from "../../constants/featureFlags.js";
import { useFeature } from "../../hooks/useFeature.js";

const ControlCenterHeaderButtonLoadableComponent = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "control-center/header-button" */ "./components/ControlCenter.headerButton.js"
    ),
  loading: EmptyComponent
});

export const ControlCenterHeaderButtonLoadable = () => {
  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );

  return isControlCenterActive ? (
    <ControlCenterHeaderButtonLoadableComponent />
  ) : null;
};

const ControlCenterDataLoadableComponent = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "control-center/data" */ "./components/ControlCenter.data.js"
    ),
  loading: EmptyComponent
});

export const ControlCenterDataLoadable = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );

  const shouldLoad = isAuthenticated && isControlCenterActive;

  return shouldLoad ? <ControlCenterDataLoadableComponent /> : null;
};
